import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, booleanAttribute } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { DecimalInputDirective } from '@/directives/decimal-input.directive';
import { PasswordToggleComponent } from '@/components/password-toggle/password-toggle.component';

@Component({
  selector: 'custom-input',
  templateUrl: './custom-input.component.html',
  styleUrl: './custom-input.component.scss',
  imports: [
    ReactiveFormsModule,
    DecimalInputDirective,
    PasswordToggleComponent,
  ]
})
export class CustomInputComponent {

  @Input() label = ''
  @Input() formControlItem: any
  @Input() placeholder = ''
  @Input() type = ''
  @Input() autofocus = false
  /** Extra classes appended to the native input, for callers that need to visually emphasize a specific field. */
  @Input() inputClass = ''
  /** Decimal number field accepting both "." and "," as separator; replaces `type`. */
  @Input({ transform: booleanAttribute }) decimal = false
  /** With `decimal`, always display 2 decimals (26 -> 26.00). */
  @Input({ transform: booleanAttribute }) padDecimals = false
  /** Unit appended to min/max error messages, e.g. "%" -> "Máximo 100%". */
  @Input() unit = ''
  /** Per-error-key overrides of the default error messages, e.g. `{ not100: 'Debe sumar 100%' }`. */
  @Input() errorMessages: Record<string, string> = {}

  @Output() onClick = new EventEmitter<any>();
  @Output() tabEvent = new EventEmitter<any>();

  @ViewChild('internalInput') inputElement!: ElementRef<HTMLInputElement>;


  ngAfterViewInit() {
    if (this.autofocus) {
      setTimeout(() => {
        this.inputElement?.nativeElement?.focus();
      }, 50);
    }
  }

  get nativeInput(): HTMLInputElement {
    return this.inputElement?.nativeElement;
  }

  get isRequired(): boolean {
    return !!this.formControlItem?.hasValidator?.(Validators.required);
  }

  /** First validation error of the bound control, as a concrete user-facing message. */
  get errorMessage(): string {
    const errors = this.formControlItem?.errors;
    if (!errors) return '';
    const key = Object.keys(errors)[0];
    if (this.errorMessages[key]) return this.errorMessages[key];

    const e = errors[key];
    switch (key) {
      case 'required': return 'Campo obligatorio';
      case 'email': return 'Email no válido';
      case 'min': return `Mínimo ${e.min}${this.unit}`;
      case 'max': return `Máximo ${e.max}${this.unit}`;
      case 'minlength': return `Mínimo ${e.requiredLength} caracteres`;
      case 'maxlength': return `Máximo ${e.requiredLength} caracteres`;
      case 'pattern': return 'Formato no válido';
      default: return 'Valor no válido';
    }
  }

  doClick() {
    this.onClick.emit();
  }

  doTab() {
    this.tabEvent.emit();
  }

}
